// Default
import '../../custom/js/default';

//// JS
//import '../../custom/js/indexOptimized';
//import StateSelect from '../../custom/js/components/state-variable-select';

//// Base SCSS
//import '../../custom/scss/style.scss';

//$(() => {
//	const stateSelect = new StateSelect();
//	stateSelect.init();
//});